import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { MdAdd } from 'react-icons/md';

import { IconButton } from '@mui/material';
import CreateUpdateModalDialog from 'components/CreateUpdateModalDialog';
import { State } from 'types/list';
import { Fields } from 'types/table';

interface Props {
  table?: string;
  idColumn?: string;
  getFields?:
    | ((field: any, selectedFazenda: any) => Promise<Fields[]>)
    | ((field: any) => Promise<Fields[]>);
  setRefreshInput?: Dispatch<SetStateAction<boolean>>;
  state: State;
  setState: Dispatch<SetStateAction<State>>;
}

export default function ButtonCreateModalDialog(props: Props) {
  const [open, setOpen] = useState(false);

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = async () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <IconButton aria-label="adicionar" onClick={() => handleOpen()} color="success">
        <MdAdd />
      </IconButton>
      <CreateUpdateModalDialog
        action="create"
        open={open}
        onClose={handleClose}
        table={props.table ?? ''}
        idColumn={props.idColumn ?? ''}
        getFields={props.getFields}
        setRefreshInput={props.setRefreshInput}
        state={props.state}
        setState={props.setState}
      />
    </>
  );
}
